import React, { useEffect, useState } from "react";
import "./ManagePhotos.css";
import { Link, useNavigate } from "react-router-dom";

export default function ManagePhotos() {
    const [data, setData] = useState([]);
    const [tempOrders, setTempOrders] = useState({});
    const [nestedCache, setNestedCache] = useState({});
    const navigate = useNavigate();
    const token = sessionStorage.getItem("adminToken");

    // AUTH GUARD
    useEffect(() => {
        const isAuth = sessionStorage.getItem("adminAuth");

        if (isAuth !== "true") {
            navigate("/admin-login");
        }
    }, [navigate]);

    // FETCH DATA (ONLY MAIN IMAGES)
    useEffect(() => {
        fetch("http://localhost:8000/api/v1/getallImage")
            .then((res) => res.json())
            .then((result) => {
                const updated = (result.responseData || []).map((item, index) => ({
                    ...item,
                    order: item.order ?? index + 1
                }));

                setData(updated);

                // initialize temp orders
                const initialOrders = {};
                updated.forEach((item) => {
                    initialOrders[item._id] = item.order;
                });
                setTempOrders(initialOrders);

                // ✅ FETCH NESTED IMAGES PER POST
                updated.forEach((item) => {
                    fetchNestedImages(item._id);
                });
            })
            .catch((err) => {
                console.error(err);
            });
    }, []);

    // ✅ FETCH NESTED IMAGES (NEW)
    const fetchNestedImages = async (postId) => {
        try {
            const res = await fetch(
                `http://localhost:8000/api/v1/getNestedImages/${postId}`
            );

            const result = await res.json();

            if (!result?.responseData?.nestedImagesMap) return;

            setNestedCache((prev) => ({
                ...prev,
                [postId]: result.responseData.nestedImagesMap
            }));
        } catch (err) {
            console.error("Nested fetch error:", err);
        }
    };

    // DELETE
    const handleDelete = async (postId) => {
        try {
            let response = await fetch(
                "http://localhost:8000/api/v1/DeleteSingleImage",
                {
                    method: "DELETE",
                    headers: {
                        Accept: "*/*",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        postid: postId,
                    }),
                }
            );

            let dataRes = await response.json();

            if (!response.ok) {
                alert(dataRes.message || "Delete failed");
                return;
            }

            setData((prev) =>
                prev.filter((item) => item._id !== postId)
            );

            
        } catch (error) {
            console.error("Delete error:", error);
        }
    };

    // TEMP ORDER CHANGE (ONLY LOCAL)
    const handleOrderChange = (id, newOrder) => {
        setTempOrders((prev) => ({
            ...prev,
            [id]: Number(newOrder)
        }));
    };

    // APPLY ORDER (UI + DB)
    const handleApplyOrder = async () => {
        try {

            const ordersPayload = data.map((item) => ({
                id: item._id,
                order: tempOrders[item._id]
            }));

            const res = await fetch(
                "http://localhost:8000/api/v1/updateImage",
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        orders: ordersPayload
                    })
                }
            );

            const result = await res.json();

            if (!result.success) {
                alert("Order update failed");
                return;
            }

            setData(result.responseData);

            const updatedOrders = {};

            result.responseData.forEach((item) => {
                updatedOrders[item._id] = item.order;
            });

            setTempOrders(updatedOrders);

            alert("Order updated successfully!");

        } catch (err) {
            console.error("Order update failed:", err);
        }
    };

    return (
        <div>
            <div
                style={{
                    display: "flex",
                    width: "100%",
                    marginBottom: "20px",
                }}
            >
                <Link
                    to="/ManagePhotos/CreatePhotos"
                    className="create-btn"
                    style={{
                        flex: 1,
                        textAlign: "center",
                        borderRadius: "0",
                    }}
                >
                    Create New Post
                </Link>

                <button
                    onClick={handleApplyOrder}
                    className="create-btn"
                    style={{
                        flex: 1,
                        borderRadius: "0",
                    }}
                >
                    Change Order
                </button>
            </div>

            <div className="posts-scroll">
                {data.map((item, index) => (
                    <div className="post-card" key={item._id || index}>

                        <button
                            className="delete-btn"
                            onClick={() => handleDelete(item._id)}
                        >
                            🗑
                        </button>

                        {/* DROPDOWN */}
                        <select
                            value={tempOrders[item._id] || item.order}
                            onChange={(e) =>
                                handleOrderChange(item._id, e.target.value)
                            }
                        >
                            {data.map((_, idx) => (
                                <option key={idx + 1} value={idx + 1}>
                                    Post {idx + 1}
                                </option>
                            ))}
                        </select>

                        <h3>Post {index + 1}</h3>

                        {/* MAIN IMAGES */}
                        {item.mainImages?.map((img, i) => (
                            <div key={i}>
                                <img
                                    src={img.src}
                                    alt=""
                                    className="main-img"
                                    loading="lazy"
                                />
                            </div>
                        ))}

                        {/* NESTED IMAGES (FROM API CACHE) */}
                        <div className="nested-container">
                            {nestedCache[item._id] &&
                                Object.values(nestedCache[item._id]).map(
                                    (group, i) => (
                                        <div key={i}>
                                            <h4>{group.name}</h4>

                                            <div className="nested-scroll">
                                                {group.images.map((img, j) => (
                                                    <img
                                                        key={j}
                                                        src={img.url}
                                                        alt=""
                                                        className="nested-img"
                                                        loading="lazy"
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    )
                                )}
                        </div>

                    </div>
                ))}
            </div>
        </div>
    );
}